import {
  Link,
  Outlet,
  createFileRoute,
  useLocation,
} from '@tanstack/react-router'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useAuthState, usePermissions } from '@/features/auth'

export const Route = createFileRoute('/(dashboard)/assessments')({
  component: RouteComponent,
})

function RouteComponent() {
  const location = useLocation()
  const { currentOrganization } = useAuthState()
  const { hasOrganizationRole } = usePermissions()

  // Only show tabs on main assessment routes, not on detail routes
  const isMainRoute =
    location.pathname === '/assessments' ||
    location.pathname === '/assessments/' ||
    location.pathname === '/assessments/direct-reports' ||
    location.pathname === '/assessments/direct-reports/'

  // Determine active tab based on current pathname
  const activeTab =
    location.pathname === '/assessments/direct-reports' ||
    location.pathname === '/assessments/direct-reports/'
      ? 'Direct Reports'
      : 'personal'

  // Check if user has admin or manager role
  const canViewDirectReports =
    currentOrganization?.organizationId &&
    (hasOrganizationRole(currentOrganization.organizationId, 'admin') ||
      hasOrganizationRole(currentOrganization.organizationId, 'manager'))

  if (!isMainRoute) {
    // Detail routes don't show tabs, just render the outlet
    return <Outlet />
  }

  return (
    <>
      <div className="flex items-center justify-between p-6 bg-muted/30 rounded-lg">
        <div>
          <h1 className="text-2xl font-semibold text-foreground">
            Assessments
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            Here's an overview of all assessments assigned to you.
          </p>
        </div>
      </div>
      {canViewDirectReports && (
        <Tabs value={activeTab}>
          <TabsList className="grid w-full max-w-xs grid-cols-2">
            <TabsTrigger value="personal" asChild>
              <Link to="/assessments">Personal</Link>
            </TabsTrigger>
            <TabsTrigger value="Direct Reports" asChild>
              <Link to="/assessments/direct-reports">Direct Reports</Link>
            </TabsTrigger>
          </TabsList>
        </Tabs>
      )}
      <Outlet />
    </>
  )
}
